import { MobiDocument } from './MobiDocument';
import { ChampLibreResultDocument } from './ChampLibreResultDocument';

export class FamilleChampLibreResultDocument extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private infa_famille_id: number;
    private listechamplibreresults_id: number;

    public constructor(famChampLibreResult: any) {
        super()
        this._id = famChampLibreResult._id;
        this._rev = famChampLibreResult._rev;
        this.id = famChampLibreResult.id;
        this.infa_famille_id = famChampLibreResult.infa_famille_id;
        this.listechamplibreresults_id = famChampLibreResult.listechamplibreresults_id
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getInfa_famille_id(): number {
        return this.infa_famille_id;
    }

    public setInfa_famille_id(infa_famille_id: number): void {
        this.infa_famille_id = infa_famille_id;
    }

    public getListechamplibreresults_id(): number {
        return this.listechamplibreresults_id;
    }

    public setListechamplibreresults_id(listechamplibreresults_id: number): void {
        this.listechamplibreresults_id = listechamplibreresults_id;
    }


    public getChampLibreResultDocument() : ChampLibreResultDocument{
        return this.memdb.findOne({
            doctype: "ChampLibreResultDocument",
            fkey: "id",
            fvalue: this.listechamplibreresults_id
        });
    }

}